import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import 'rxjs/add/operator/map';

import {StorageService} from "./storage";

@Injectable()
export class AuthService {

  constructor(public http: Http, public storageService: StorageService) {}

  getCurrentServerId() {
    return ''
  }

  getCurrentUsername() {
    return ''
  }

  setCredentials(serverId: number, username, password, hostname) {
    this.storageService.set('username' + serverId, username);
    this.storageService.set('password' + serverId, password);
    this.storageService.set('hostname' + serverId, hostname);
    // this.storageService.set('hostname' + serverId, hostname);
  }

  login(serverId) {
    this.storageService.set('currentServer', serverId);
  }

  relogin() {

  }
}



// WEBPACK FOOTER //
// ./src/providers/auth-service.ts